import React from 'react';
import './wind.css';
import { CircularGaugeComponent, AxesDirective, AxisDirective, Inject, Annotations, AnnotationDirective, PointersDirective, PointerDirective, RangesDirective, RangeDirective, AnnotationsDirective } from '@syncfusion/ej2-react-circulargauge';
import Constants from '../../models/constants';
import Weather from '../../models/weather';

const Wind: React.FC<{weather: Weather}> = ({weather}) => {
    const speed: number = (weather.last5min?.windSpeed ?? 0) * 3600 / 1000;
    const speedStr: string = speed.toFixed(1);
    const cardinalDirection: string  = weather.last5min?.cardinalDirection ?? "W";
    const windDirection: number = weather.last5min?.windDirection ?? -90;
    const speedometerColor: string = speed < 20 ? Constants.lightBlue : speed < 48 ? Constants.green : Constants.orange;
    let reversedWindDirection = windDirection;

    // Ensure the reversed direction is within the range of -180 to 180
    if (reversedWindDirection < -180) {
        reversedWindDirection += 180;
    } else if (reversedWindDirection > 180) {
        reversedWindDirection -= 180;
    } else {
        if (reversedWindDirection < 0) {
            reversedWindDirection += 180;
        } else if (reversedWindDirection > 0) {
            reversedWindDirection -= 180;
        }
    }
    return (
        <div className="wind-container">
            <div className='wind-title'>
                Wind
            </div>
            <CircularGaugeComponent 
                background={Constants.grey}
                className='wind-component'>
                <Inject services={[Annotations]}/>
                <AxesDirective>
                    <AxisDirective radius='120%' startAngle={270} endAngle={90} minimum={0} maximum={50} lineStyle={{ width: 0 }} majorTicks={{ height: 0, interval: 0 }} minorTicks={{ height: 0 }} 
                    >
                        <RangesDirective>
                            <RangeDirective start={0} end={50} radius='120%' startWidth={15} endWidth={15} color='#001F4E' roundedCornerRadius={10}>
                            </RangeDirective>
                        </RangesDirective>
                        <AnnotationsDirective>
                            <AnnotationDirective content={`<div><div><span>50km/h</span></div></div>`} zIndex='1' radius='120%' angle={100}/>
                        </AnnotationsDirective>
                        <PointersDirective>
                            <PointerDirective animation={{ enable: false }} value={speed < 0.3 ? (speed === 0 ? 0 : 0.3) : speed } radius='120%' color={speedometerColor} pointerWidth={15} type='RangeBar' roundedCornerRadius={5} border={{
                                color: 'gray',
                                width: 0
                            }}/>
                        </PointersDirective>
                    </AxisDirective>
                    <AxisDirective radius='65%' startAngle={0} endAngle={360} minimum={-180} maximum={180} direction='ClockWise' lineStyle={{ width: 0 }} labelStyle={{
                        font: {
                            fontWeight: 'Roboto',
                            fontStyle: 'Regular',
                            size: '0px',
                            color: 'white'
                        },
                        position: 'Inside',
                        useRangeColor: true
                    }} majorTicks={{ height: 15, interval: 90, color:'#001F4E' }} minorTicks={{ height: 0 }}>
                        <AnnotationsDirective>
                            <AnnotationDirective content='<div id="slider" style="height:70px;width:250px;"></div>' angle={0} radius='-100%' zIndex='1'/>
                        </AnnotationsDirective>
                        <RangesDirective>
                            <RangeDirective start={-180} end={180} radius='80%' startWidth={5} endWidth={5} color='#001F4E' roundedCornerRadius={0}>
                            </RangeDirective>
                        </RangesDirective>
                        <PointersDirective>
                            <PointerDirective value={reversedWindDirection}
                                animation={{
                                    enable: false, duration: 900
                                }}
                                radius='100%' color='#9F8031' pointerWidth={30}
                                cap={{
                                    radius: 10,
                                    color: 'white',
                                    border: {
                                        color: '#9F8031',
                                        width: 8
                                    }
                                }}
                                    />
                        </PointersDirective>
                    </AxisDirective>
                </AxesDirective>
            </CircularGaugeComponent>
            <div className='wind-text-container'>
                <span className='wind-speed-direction'>
                    <span className='large-text'>
                        {speedStr}
                    </span>
                    <span className='bigger-text'>
                        {` km/h`}
                    </span>
                    <span className='large-text'>
                        {` ${cardinalDirection}`}
                    </span>
                </span>
            </div>
        </div>
    );
}



export default Wind;